import { createSlice } from "@reduxjs/toolkit";

export const subCategorySlice = createSlice({
  name: "subcategory",
  initialState: {
    subcategories: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    getSubCategoryStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getSubCategorySuccess: (state, action) => {
      state.isFetching = false;
      state.subcategories = action.payload;
    },
    getSubCategoryFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
  },
});

export const { getSubCategoryStart, getSubCategorySuccess, getSubCategoryFailure } =
  subCategorySlice.actions;

export default subCategorySlice.reducer;
